export default function PageHeader({ title, subtitle, actions }) {
  return (
    <div className="flex items-start justify-between gap-4 mb-8">
      <div>
        <h1 className="font-display text-2xl lg:text-3xl text-[hsl(var(--zt-teal))] font-bold">{title}</h1>
        {subtitle && <p className="text-sm text-[hsl(var(--zt-charcoal))]/60 mt-1 font-body">{subtitle}</p>}
      </div>
      {actions && <div className="flex items-center gap-3 flex-shrink-0">{actions}</div>}
    </div>
  );
}
